import api from '../api'; // your Axios instance

export function getVacancies() {
    return api.get('/dashboard/vacancies/fetch');
}

export function addVacancy(formData: FormData) {
    return api.post('/dashboard/vacancies/store', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

export function getVacancyById(id: number) {
    return api.get(`/dashboard/vacancies/fetch-single/${id}`);
}

export function deleteVacancy(id: number) {
    const formData = new FormData();
    formData.append('id', String(id));

    return api.post('/dashboard/vacancies/delete', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

export function updateVacancy(formData: FormData, id: number) {
    return api.post(`/dashboard/vacancies/update/${id}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

